
const getDefaultFilter = () => ({
  page: 1,
  offset: 0,
  limit: 10,
  sort: 'nb_annonces',
  search: '',
  preset: 'enable'
})

const getPresetFilters = () => ({
  preset: 'enable'
})

export default {
  namespaced: true,
  state: {
    tabs: [],
    filter: getDefaultFilter(),
    results: { total: -1, list: [] }
  },
  getters: {
  },
  mutations: {
    setTabs (state, tabs) {
      state.tabs = tabs
    },
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1 }
    },
    addFilter (state, filter) {
      state.filter = { ...state.filter, ...filter }
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    }
  }
}
